module.exports = __webpack_public_path__ + "img/people.aa1b4592.png";